import { Route, Navigate, Routes } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useAuth } from 'hooks'

import {
  BackgroundImage,
  StyledCard,
  CardImage,
  ContentContainer,
  CardContent,
  CardImageTitle,
  ContentHeader,
  Overlay,
  CardContainer,
} from './components'
import {
  Login,
  Signup,
  VerifyEmail,
  ForgotPassword,
  PasswordChangeRequest,
  PasswordChange,
} from './features'

export const LoginRouter: React.FC = () => {
  const { t } = useTranslation('login')

  const { userId } = useAuth()

  if (userId) return <Navigate to="/map" replace />

  return (
    <BackgroundImage>
      <Overlay />
      <CardContainer>
        <Overlay />
        <StyledCard bodyStyle={{ padding: 0, height: '100%' }}>
          <CardContent>
            <CardImage>
              <CardImageTitle>{t('loginPage.heroTitle')}</CardImageTitle>
            </CardImage>
            <ContentContainer>
              <ContentHeader />
              <Routes>
                <Route index element={<Login />} />
                <Route path="signup" element={<Signup />} />
                <Route path="verify-email" element={<VerifyEmail />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="password-change-request" element={<PasswordChangeRequest />} />
                <Route path="password-change" element={<PasswordChange />} />
              </Routes>
            </ContentContainer>
          </CardContent>
        </StyledCard>
        <Overlay />
      </CardContainer>
      <Overlay />
    </BackgroundImage>
  )
}
